import {
  EMPLOYER_INITIAL_STATE,
  EMPTY_DISCOUNT,
  EMPTY_SUBSCRIPTION,
  FETCH_CUSTOMER_DETAILS,
  FETCH_EMPLOYER_COMPANY_PROFILE,
  FETCH_EMPLOYER_COUPONS,
  FETCH_EMPLOYER_DRAFT_JOBS,
  FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS,
  FETCH_EMPLOYER_FREE_JOBS,
  FETCH_EMPLOYER_MODE,
  FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS,
  FETCH_EMPLOYER_PAID_JOBS,
  FETCH_OPEN_INVOICES,
  SELECT_EMPLOYER_DRAFT_JOB,
  SELECT_EMPLOYER_REPOST_JOB,
} from "./employerConstanst";
import { SIGN_OUT_USER } from "../auth/authConstants";

export default function employerReducer(
  state = EMPLOYER_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_EMPLOYER_PAID_JOBS:
      return {
        ...state,
        jobs: payload,
      };
    case FETCH_EMPLOYER_FREE_JOBS:
      return {
        ...state,
        freebies: {
          ...state.freebies,
          jobs: payload,
        },
      };
    case FETCH_EMPLOYER_DRAFT_JOBS:
      return {
        ...state,
        draftJobs: payload,
      };
    case SELECT_EMPLOYER_DRAFT_JOB:
      return {
        ...state,
        selectedDraftJob: payload,
      };
    case SELECT_EMPLOYER_REPOST_JOB:
      return {
        ...state,
        selectedRepostJob: payload,
      };
    case FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS:
      return {
        ...state,
        companyFeaturedLogos: payload,
      };
    case FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS:
      return {
        ...state,
        freebies: {
          ...state.freebies,
          companyFeaturedLogos: payload,
        },
      };
    case FETCH_EMPLOYER_COMPANY_PROFILE:
      return {
        ...state,
        companyProfile: payload,
      };
    case FETCH_EMPLOYER_COUPONS:
      return {
        ...state,
        coupons: payload,
      };
    case FETCH_EMPLOYER_MODE:
      return {
        ...state,
        mode: {
          newFeatures: payload.newFeatures || [],
        },
      };
    case FETCH_CUSTOMER_DETAILS:
      return {
        ...state,
        subscription: payload.subscription || EMPTY_SUBSCRIPTION,
        discount: payload.discount || EMPTY_DISCOUNT,
      };
    case FETCH_OPEN_INVOICES:
      return {
        ...state,
        openInvoices: payload,
      };
    case SIGN_OUT_USER:
      return {
        ...state,
        ...EMPLOYER_INITIAL_STATE,
      };
    default:
      return state;
  }
}
